// ============================================
// PORTAL CONSTRUCCIÓN SUSTENTABLE
// CTA U-STUCCO + Sticky Bar + Proxy Groq
// Compartido para todos los artículos
// ============================================

(function () {
  'use strict';

  // --- Proxy Groq ---
  var PROXY_URL = 'https://groq-proxy.francisco-zeising.workers.dev';

  window.portalCallIA = async function (systemInstruction, userText) {
    var response = await fetch(PROXY_URL, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ systemInstruction: systemInstruction, userText: userText })
    });
    var data = await response.json();
    return data.text || 'Lo siento, no pude generar una respuesta.';
  };

  // --- Sticky Bar ---
  var stickyBar   = document.getElementById('portal-sticky');
  var stickyClose = document.getElementById('portal-sticky-close');

  if (stickyBar) {
    function checkScroll() {
      if (window.scrollY > 400) {
        stickyBar.classList.add('visible');
      }
    }
    window.addEventListener('scroll', checkScroll);
    setTimeout(checkScroll, 500);

    if (stickyClose) {
      stickyClose.addEventListener('click', function () {
        stickyBar.classList.remove('visible');
        window.removeEventListener('scroll', checkScroll);
      });
    }
  }

  // --- Tabs genéricos ---
  document.querySelectorAll('.art-tab-btn').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var tabId = btn.dataset.tab;
      document.querySelectorAll('.art-tab-btn').forEach(function (b) {
        b.classList.toggle('active', b.dataset.tab === tabId);
      });
      document.querySelectorAll('.art-tab-panel').forEach(function (panel) {
        panel.classList.toggle('active', panel.dataset.panel === tabId);
      });
    });
  });

})();
